import { Button } from 'primereact/button';

import { formatCurrency } from '../../utils/CommonUtils';
import EmptyState from '../common/EmptyState';
import Money from '../common/Money';

/**
 * Кошик замовлення.
 *
 * Було: DataTable у режимі editMode="cell" — щоб змінити кількість,
 * касир мав влучити пальцем у комірку, дочекатися появи поля вводу
 * і надрукувати число. Стало: кроковий лічильник з цілями 36×36 px.
 */
const Cart = ({ items, totals, totalUAH, onChangeQuantity, onRemove, onCheckout }) => (
    <div className="rc-cart">
        <div className="rc-cart__list">
            {items.length === 0 ? (
                <EmptyState
                    icon="pi pi-shopping-cart"
                    title="Кошик порожній"
                    text="Оберіть товар у каталозі або відскануйте штрих-код"
                />
            ) : (
                items.map((item, index) => (
                    <div className="rc-line-item" key={`${item.item_type}-${item.id}-${index}`}>
                        <div className="rc-line-item__main">
                            <div className="rc-line-item__name">{item.name}</div>
                            <div className="rc-line-item__meta">
                                <span>{formatCurrency(item.price, item.currency)}</span>
                                {item.product_identifier && (
                                    <span>· IMEI {item.product_identifier}</span>
                                )}
                            </div>
                        </div>

                        <div className="rc-line-item__side">
                            {item.product_identifier ? (
                                // Товар з IMEI завжди в одному екземплярі
                                <span className="rc-stepper__value">1</span>
                            ) : (
                                <span className="rc-stepper">
                                    <button
                                        type="button"
                                        className="rc-stepper__btn"
                                        aria-label="Зменшити кількість"
                                        disabled={(item.quantity ?? 1) <= 1}
                                        onClick={() =>
                                            onChangeQuantity(index, (item.quantity ?? 1) - 1)
                                        }
                                    >
                                        <i className="pi pi-minus" />
                                    </button>
                                    <span className="rc-stepper__value">{item.quantity ?? 1}</span>
                                    <button
                                        type="button"
                                        className="rc-stepper__btn"
                                        aria-label="Збільшити кількість"
                                        onClick={() =>
                                            onChangeQuantity(index, (item.quantity ?? 1) + 1)
                                        }
                                    >
                                        <i className="pi pi-plus" />
                                    </button>
                                </span>
                            )}

                            <Button
                                type="button"
                                icon="pi pi-times"
                                severity="danger"
                                text
                                rounded
                                aria-label={`Прибрати ${item.name}`}
                                onClick={() => onRemove(index)}
                            />
                        </div>
                    </div>
                ))
            )}
        </div>

        {items.length > 0 && (
            <div className="rc-cart__footer">
                {totals.map((total) => (
                    <div className="rc-cart__total" key={`cart-total-${total.currency}`}>
                        <span className="rc-cart__total-label">Разом, {total.currency}</span>
                        <span className="rc-cart__total-value">
                            <Money value={total.sum} currency={total.currency} />
                        </span>
                    </div>
                ))}

                {totals.length > 1 && (
                    <div className="rc-cart__total">
                        <span className="rc-cart__total-label">Еквівалент</span>
                        <span className="rc-cart__total-value">
                            <Money value={totalUAH} currency="UAH" />
                        </span>
                    </div>
                )}

                <Button
                    label="Перейти до оплати"
                    icon="pi pi-arrow-right"
                    iconPos="right"
                    className="w-full"
                    onClick={onCheckout}
                />
            </div>
        )}
    </div>
);

export default Cart;
